module.exports = __webpack_public_path__ + "img/bg-sr.1e838b84.jpg";